import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  BackNextButton,
  AddButton,
  Modal,
  EditCard,
  Button,
} from "../../../../../common";
import { EditCardItems } from "../EditCardItems";
import { AddAuthorizedSignFrom } from "./AddAuthorizedSignForm";
import { ReactComponent as Pen } from "../../../../../../assets/images/companyIcons/pen.svg";
import { ReactComponent as Designation } from "../../../../../../assets/images/companyIcons/CompanyProfile/designation.svg";
import { ReactComponent as EmailIcon } from "../../../../../../assets/images/companyIcons/CompanyProfile/email.svg";
import { ReactComponent as NameIcon } from "../../../../../../assets/images/companyIcons/CompanyProfile/name.svg";
import { ReactComponent as NationalityIcon } from "../../../../../../assets/images/companyIcons/CompanyProfile/nationality.svg";
import { ReactComponent as TelephoneIcon } from "../../../../../../assets/images/companyIcons/CompanyProfile/telephone.svg";
import { useGetCompanyQuery, useCreateauthorizedsignDraftFetchMutation, useUpdateAuthorizedSignMutation, useDeleteAuthSignDraftMutation } from "../../../../../../store/Company/companyApiSlice";
import { setCurrentEditingCompany } from "../../../../../../store/Company/companySlice";
import { ReactComponent as Delete } from "../../../../../../assets/images/companyIcons/delete1.svg"
import { ReactComponent as Verified } from "../../../../../../assets/icons/verified.svg";
import { ReactComponent as Declined } from "../../../../../../assets/icons/cancel.svg";
import { ReactComponent as Requested } from "../../../../../../assets/icons/pending.svg";
import { ReactComponent as Skipped } from "../../../../../../assets/icons/review.svg";

export const AuthorizedSignatory = ({ onPrev, onNext, onSkip, handleUpdateStatus, compRefetch }) => {
  const dispatch = useDispatch();
  const [authorizedSignatory, setAuthorizedSignatory] = useState([]);
  const [authorizedSignatoryDraft, setAuthorizedSignatoryDraft] = useState([]);
  const [company_authorized_signID, setcompany_authorized_signID] = useState(null)
  const [editAuthorized, setEditAuthorized] = useState(null);
  const [isOpen, setIsOpen] = useState(false);
  const { currentEditingCompany } = useSelector((state) => state.company);
  const { token } = useSelector((state) => state.auth);
  const [authorizedsignDraft] = useCreateauthorizedsignDraftFetchMutation();
  const [deleteDraft] = useDeleteAuthSignDraftMutation();
  const [dataChanged, setDataChanged] = useState(false);

  const [updateAuthorizedSign] = useUpdateAuthorizedSignMutation();
  const { data, isLoading, refetch } = useGetCompanyQuery({
    companyId: currentEditingCompany?.companyID,
    token,
  });

  useEffect(() => {
    if (data) {
      dispatch(setCurrentEditingCompany(data));
    }
  }, [data, dispatch, isOpen, dataChanged]);
  const modalHandleDelete = async (deleteInfo) => {
    if (deleteInfo?.authorized_sign_draftID) {
      let dataval = await deleteDraft({
        data: deleteInfo?.authorized_sign_draftID,
      });
      if (dataval?.data == null) {
        alert("Authorized Signatory Deleted Successfully");
        refetch();
        compRefetch();
        setDataChanged(!dataChanged);
        // window.location.reload()
      }
    } else if (deleteInfo?.authorized_signID) {
      let res = await updateAuthorizedSign({
        data: { is_deleted: 1 },
        authorized_signID: deleteInfo?.authorized_signID,
        token,
      }).unwrap();
      if (res?.is_deleted == 1) {
        handleUpdateStatus()
        alert("Authorized Signatory Deleted Successfully");
        // window.location.reload()
        refetch();
        compRefetch();
        setDataChanged(!dataChanged);
      }
    }
  }
  useEffect(() => {
    if (!currentEditingCompany) return;
    let resultArr = [];
    let Dettemp = currentEditingCompany?.authorizedSignDetails?.forEach(function (obj) {
      if (obj?.Authorized_signID?.is_deleted == 0) {
        resultArr.push(obj)
      }
    });
    setAuthorizedSignatory(resultArr);
    if (resultArr.length > 0) {

      setcompany_authorized_signID(resultArr[0]['Authorized_signID']?.authorized_signID)
    }
    const companyStatus = async () => {
      let dataval = await authorizedsignDraft({
        companyID: currentEditingCompany?.companyID,
        token,
      });
      if (dataval) {
        let respData = dataval?.data?.data;
        let tempArr = [];
        let draft_ids = [];
        let ids = [];
        let main_ids = [];
        for (let i = 0; i < respData.length; i++) {
          draft_ids.push(respData[i]?.authorized_signID_id);
          tempArr.push(respData[i]);
        }
        currentEditingCompany?.authorizedSignDetails?.forEach(function (obj) {
          if (obj?.Authorized_signID?.is_deleted == 0) {
            ids.push(obj?.Authorized_signID?.authorized_signID)
          }
        });
        ids.forEach(function (id) {
          if (!draft_ids.includes(id))
            main_ids.push(id)
        })
        currentEditingCompany?.authorizedSignDetails?.forEach(function (obj) {
          if (obj?.Authorized_signID?.is_deleted == 0) {
            if (main_ids.includes(obj?.Authorized_signID?.authorized_signID)) {
              tempArr.push(obj?.Authorized_signID)
            }
          }
        });
        setAuthorizedSignatoryDraft(tempArr)

      }

    }
    companyStatus();
  }, [currentEditingCompany, dataChanged]);

  const modalHandle = (authId) => {
    setEditAuthorized(authId);
    setIsOpen(!isOpen);
    refetch();
    setDataChanged(!dataChanged);
  };
  function createArrayFromObject(object) {
    let otherData = [
      "designation",
      "name",
      "work_email",
      "nationality",
      "work_mobile",
    ];
    let icons = {
      name: <NameIcon />,
      designation: <Designation />,
      work_email: <EmailIcon />,
      work_mobile: <TelephoneIcon />,
      nationality: <NationalityIcon />,
    };

    let data = [];

    for (let key in object) {
      if (otherData.includes(key)) {
        data.push({ [key]: object[key], icon: icons[key] });
      }
    }

    let keyValuePairs = data.map((item) =>
      Object.entries(item).map(([key, value]) => [key, value])
    );

    let html = keyValuePairs.map((item) => (
      <EditCardItems
        heading={item[0][0]?.replaceAll("_", " ")}
        subHeading={item[0][1]?.replace("|", "")}
        icon={item[1][1]}
      />
    ));
    return html;
  }

  return (
    <div className="mt-5 mr-20">
      {isOpen && (
        <Modal modalHandle={modalHandle}>
          <AddAuthorizedSignFrom
            editAuthorized={editAuthorized}
            modalHandle={modalHandle}
            refetch={refetch}
            compRefetch={compRefetch}
            dataChanged={dataChanged}
            setDataChanged={setDataChanged}
          />
        </Modal>
      )}
      <h3 className="text-f20 font-semibold text-secondarytwo text-left mb-2">
        Authorized Signatory
      </h3>

      <div className="border border-slate rounded-lg p-8 mb-6">
        <AddButton
          text="Add New Authorized Signatory"
          buttonText="Add"
          onClick={() => modalHandle(null)}
        />
        <div className="grid grid-cols-2 gap-4">
          {authorizedSignatoryDraft.length <= 0 && authorizedSignatory?.map((item, index) => (
            <EditCard>
              <div className="statusSection">
                {item.Authorized_signID.status === "Verified" && (
                  <Verified />
                )}
                {item.Authorized_signID.status === "Declined" && (
                  <Declined />
                )}
                {item.Authorized_signID.status === "Skipped" && (
                  <Skipped />
                )}
                {(item.Authorized_signID.status === "Requested" || item.Authorized_signID.status === "raised" || item.Authorized_signID.status === "pending") && (
                  <Requested />
                )}
              </div>
              <div className="h-[18rem] overflow-y-auto relative  my-2">
                {createArrayFromObject(item?.Authorized_signID)}
              </div>
              {<div className="actionseditDelete  gap-4">

                  <Button
                    onClick={() => modalHandle(item?.Authorized_signID)}
                    classes="bg-white/[.2] w-full border border-white/[0.3] rounded flex items-center justify-center gap-2 p-2 text-white relative"
                  >
                    <span>Edit Details</span>
                    <span>
                      <Pen />
                    </span>
                  </Button>
                  <Button
                    onClick={() => modalHandleDelete(item?.Authorized_signID)}
                    classes="bg-white/[.2] w-full border border-white/[0.3] rounded flex items-center justify-center gap-2 p-2 text-white relative"
                  >
                    <span>Delete</span>
                    <span>
                      <Delete />
                    </span>
                  </Button>
                </div>
              }
            </EditCard>
          ))}
          {authorizedSignatoryDraft?.map((item, index) => (
            <EditCard>
              <div className="statusSection">
                {item?.status === "Verified" && (
                  <Verified />
                )}
                {item?.status === "Declined" && (
                  <Declined />
                )}
                {item?.status === "Skipped" && (
                  <Skipped />
                )}
                {(item?.status === "Requested" || item?.status === "raised" || item?.status === "pending") && (
                  <Requested />
                )}
              </div>
              <div className="h-[18rem] overflow-y-auto relative  my-2">
                {createArrayFromObject(item)}
              </div>
              {<div className="actionseditDelete  gap-4">

                  <Button
                    onClick={() => modalHandle(item)}
                    classes="bg-white/[.2] w-full border border-white/[0.3] rounded flex items-center justify-center gap-2 p-2 text-white relative"
                  >
                    <span>Edit Details</span>
                    <span>
                      <Pen />
                    </span>
                  </Button>
                  <Button
                    onClick={() => modalHandleDelete(item)}
                    classes="bg-white/[.2] w-full border border-white/[0.3] rounded flex items-center justify-center gap-2 p-2 text-white relative"
                  >
                    <span>Delete</span>
                    <span>
                      <Delete />
                    </span>
                  </Button>
                </div>
              }
            </EditCard>
          ))}
        </div>
      </div>

      <BackNextButton
        onPrev={() => onPrev(2, "Ownership Structure", "Details")}
        onNext={() => onNext(3, "Key Personnel", "Details")}
        onSkip={() => onSkip(3, "Key Personnel", "Details")}
      />
    </div>
  );
};
